type ListsRetrievalFilter = {
  start: number;
  limit: number;
};

const listsRetrievalFilter: ListsRetrievalFilter = { limit: 0, start: 0 };

export type { ListsRetrievalFilter };

export { listsRetrievalFilter };
